export default __webpack_public_path__ + "static/mobile-dcaadff2e917044eb8346afe5089d5f4.svg";